import { render, staticRenderFns } from "./scholarChord.vue?vue&type=template&id=60aee188&scoped=true"
import script from "./scholarChord.vue?vue&type=script&lang=js"
export * from "./scholarChord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aee188",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60aee188')) {
      api.createRecord('60aee188', component.options)
    } else {
      api.reload('60aee188', component.options)
    }
    module.hot.accept("./scholarChord.vue?vue&type=template&id=60aee188&scoped=true", function () {
      api.rerender('60aee188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/comps/scholarChord.vue"
export default component.exports